import axiosInstance from "@API/axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "@Redux/snackBarSlice";
import { useState } from "react";

const useDeleteItem = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const deleteItem = (
    id,
    deleteCallback,
    url,
    successMessage,
    errorMessage
  ) => {
    setLoading(true);
    axiosInstance
      .delete(`${url}/${id}`)
      .then((response) => {
        setLoading(false);
        dispatch(
          setSnackbar({
            open: true,
            message: successMessage,
            error: false,
          })
        );
        deleteCallback(id);
      })
      .catch((error) => {
        if (error.response.status === 409) {
          deleteCallback(id, error);
        } else if (error.response.status === 404) {
          dispatch(
            setSnackbar({
              open: true,
              message: "The item doesn't exist!",
              error: true,
            })
          );
        } else {
          dispatch(
            setSnackbar({
              open: true,
              message:
                errorMessage || "An error occurred while deleting the item",
              error: true,
            })
          );
        }
        setLoading(false);
      });
  };
  return { loading, deleteItem };
};

export default useDeleteItem;
